import { APIClient, ApiQueryParams, DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { IGroup } from '@frontend/group/types';
import { IProduct, ProductListResponse, ProductQueryParams } from '@frontend/product/types';

export class ProductConsumeClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    /**
     * This function will return a list of products and categories that can be consumed or lent to the user.
     * Parent Category id should be provided.
     *
     * Used for tree browsing.
     */
    public static async fetchCategoryConsumeLendProducts(
        accountId: string,
        category_id: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>,
        withCredentials?: Token
    ): Promise<PaginatedResponse<IProduct | IGroup>> {
        return await this.apiPaginated<PaginatedResponse<IProduct | IGroup>, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/product-categories/${category_id}/consume-lend-categories`,
            queryParams,
            withCredentials
        );
    }

    /**
     * Will return a list of products and LEAF categories that can be consumed or lent to the user.
     * Basically a fetch All for the user.
     */
    public static async fetchConsumeLendProducts(
        queryParams?: ApiQueryParams<DefaultQueryParams>,
        withCredentials?: Token
    ): Promise<PaginatedResponse<IProduct | IGroup>> {
        return await this.apiPaginated<PaginatedResponse<IProduct | IGroup>, DefaultQueryParams>(
            `${this.endpoint}/consume-lend-products`,
            queryParams,
            withCredentials
        );
    }

    public static async fetchConsumeLendRecentProducts(
        accountId: string,
        userId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>,
        withCredentials?: Token
    ): Promise<ProductListResponse> {
        return await this.apiPaginated<ProductListResponse, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/users/${userId}/consume-lend-most-recently-used-products`,
            queryParams,
            withCredentials
        );
    }

    public static async fetchReplenishProducts(
        queryParams?: ApiQueryParams<ProductQueryParams | DefaultQueryParams>,
        withCredentials?: Token
    ): Promise<ProductListResponse> {
        return await this.apiPaginated<ProductListResponse, ProductQueryParams | DefaultQueryParams>(
            `${this.endpoint}/replenish-products`,
            queryParams,
            withCredentials
        );
    }
}
